import React from 'react';

// Types ----

type HasOfferSelectProps = {
  id: string
  name: string
  label: string
  value?: number | string | null
  onChange: (hasOffer: boolean | null) => any
}

// Component ----

function HasOfferSelect({id, name, label, value, onChange}: HasOfferSelectProps) {

  function handleChange(value: string | null) {
    onChange(value === null || value === '' ? null : Boolean(Number(value)))
  }

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>

      <select
        id={id}
        name={name}
        className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand focus:outline-none focus:ring-brand sm:text-sm"
        value={value ?? undefined}
        onChange={event => handleChange(event.currentTarget.value)}
      >
        <option value="">Yes/No</option>
        <option value="1">Yes</option>
        <option value="0">No</option>
      </select>
    </div>
  );
}

export default HasOfferSelect;